class SpotGenerator {
    static STORAGE_PREFIX = "neurosfera_spots";
    static STORAGE_VERSION = 1;

    static getStorageKey(key, count) {
        return `${this.STORAGE_PREFIX}:${this.STORAGE_VERSION}:${key}:${count}`;
    }

    static readFromCache(key, count) {
        try {
            const raw = localStorage.getItem(this.getStorageKey(key, count));
            if (!raw) return null;

            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed) || parsed.length !== count) return null;

            const isValid = parsed.every((spot, index) =>
                spot &&
                typeof spot.id === "string" &&
                spot.id === `${key}-${index}` &&
                typeof spot.rotation === "number" &&
                typeof spot.duration === "number" &&
                typeof spot.delay === "number"
            );

            return isValid ? parsed : null;
        } catch {
            return null;
        }
    }

    static writeToCache(key, count, spots) {
        try {
            localStorage.setItem(
                this.getStorageKey(key, count),
                JSON.stringify(spots)
            );
        } catch {
            // Ignore storage write failures and keep runtime generation working.
        }
    }

    static async generate(key, count = 4) {
        const cachedSpots = this.readFromCache(key, count);
        if (cachedSpots) return cachedSpots;

        await new Promise(resolve => setTimeout(resolve, 300));

        const min = 2;
        const max = 7;

        const spots = Array.from({ length: count }, (_, i) => {
            const random = Math.floor(Math.random() * (max - min + 1)) + min;
            const sign = random % 2 === 1 ? 1 : -1;

            return {
                id: `${key}-${i}`,
                rotation: sign * random * 5,
                duration: random + 10,
                delay: random
            };
        });

        this.writeToCache(key, count, spots);

        return spots;
    }
}

export default SpotGenerator;
